import Component from 'flarum/common/Component';
import extractText from 'flarum/common/utils/extractText';
/**
 * A single "download/export" link button - shared by CartothequePage (4:
 * flagged/all/xlsx/pdf) and ExhibitionPage (2: xlsx/pdf). Rewrites its own
 * href with a fresh cache-buster right before the click is followed - the
 * URL never changes between downloads (?allCards=false, .xlsx, .pdf, ...
 * all stay the same), so a browser happily serves the previous download
 * back from cache instead of re-requesting otherwise (confirmed: the
 * server itself was always building the right file - only a browser's
 * cache masked that). Rebuilt from `href` fresh on every click (not
 * appended to `e.currentTarget.href`) so clicking twice without a redraw
 * in between doesn't pile up `_=` params; doesn't cover a bare
 * right-click-"open in new tab" with no click event, but that's not this
 * button's normal path.
 *
 * Attrs:
 * - href, icon (e.g. "fa-print"), label: required.
 * - title: defaults to `label` - only CartothequePage's own "download
 *   flagged" button overrides it (a different message while disabled).
 * - disabled: skips the href/cache-bust entirely, same shape as a plain
 *   disabled link elsewhere in this codebase.
 * - onBeforeClick(e): runs after the disabled check but before the
 *   cache-bust rewrite - return `false` (or call e.preventDefault()
 *   itself) to cancel the click, same as a plain onclick would. Used by
 *   CartothequePage's "download flagged" button for its confirm() dialog
 *   and downloadFlaggedCards() follow-up.
 */
export default class ExportLinkButton extends Component {
  view() {
    const {
      href,
      icon,
      label,
      title,
      disabled,
      onBeforeClick
    } = this.attrs;
    const displayTitle = title !== undefined ? title : label;
    return m("a", {
      className: 'Button ChampisExhibitions-exportButton' + (disabled ? ' ChampisExhibitions-exportButton--disabled' : ''),
      "aria-label": extractText(label),
      "aria-disabled": disabled,
      title: extractText(displayTitle),
      href: disabled ? undefined : href,
      target: "_blank",
      rel: "noopener noreferrer",
      onclick: e => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        if (onBeforeClick && onBeforeClick(e) === false) {
          e.preventDefault();
          return;
        }
        e.currentTarget.href = `${href}${href.includes('?') ? '&' : '?'}_=${Date.now()}`;
      }
    }, m("i", {
      className: `icon fas ${icon}`,
      "aria-hidden": "true"
    }), m("span", {
      className: "ChampisExhibitions-exportButtonLabel"
    }, label));
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/ExportLinkButton', ExportLinkButton);